import defaultState from './default';
import disabled from './disabled';
import active from './active';
import hover from './hover';

export default {
  default: defaultState,
  disabled,
  active,
  hover,
};
